export interface FinnPartnerId {
  id?: number;
  name?: string;
  partner_id: string;
  is_default?: boolean;
}

export interface FinnIndustry {
    id: number;
    display_value: string;
    value: string;
}

export interface FinnDurations {
    display: string;
    display_value: string;
}

export interface FinnSectors {
    display: string;
    display_value: string;
}

export interface FinnStatics {
    durations: FinnDurations[];
    sectors: FinnSectors[];
}

export interface FinnOccupation {
    id: number;
    display_value: string;
    value: string;
}

export interface FinnJobType {
    display_value: string;
    value: FinnJobTypes;
}

export enum FinnJobTypes {
    JOB = 'JOB',
    JOB_EXECUTIVE = 'JOB_EXECUTIVE',
    JOB_PARTTIME = 'JOB_PARTTIME',
}

export interface FinnManagerType {
    display_value: string;
    value: FinnManagerTypes;
}

export enum FinnManagerTypes {
    SENMANAGER = 'SENMANAGER',
    MIDMANAGER = 'MIDMANAGER',
    TECHMANAGER = 'TECHMANAGER',
}

export interface FinnContact {
    title: string,
    name: string,
    phone: string,
    email: string,
    url: string,
    twitter: string,
}
